import React from "react";

import cx from "classnames";

import styles from "./HorizontalCard.scss";

/**
 * Props for the HorizontalCard component.
 */
export interface HorizontalCardProps {
  /**
   * Component that will be rendered inside the primary section of the card
   * (the shadowed white area)
   */
  image: React.ReactNode;
  /**
   * Component that will be rendered on top of the primary section
   */
  body: React.ReactNode;
  /**
   * It will render as a data-testid prop on the HorizontalCard component
   */
  testId?: string;
  /**
   * Optional class name applied to the HorizontalCard component
   * (in addition to the default className)
   */
  className?: string;
}

export function HorizontalCard({
  image,
  body,
  testId = "horizontal-card-test-id",
  className = "",
}: HorizontalCardProps) {
  return (
    <div
      className={cx(styles["horizontal-card-wrapper"], className)}
      data-testid={testId}
    >
      <div className={styles["horizontal-card-image"]}>{image}</div>
      <div className={styles["horizontal-card-body"]}>{body}</div>
    </div>
  );
}
